export class AuthSignedInError extends Error {
	constructor() {
		super("Generic Auth Signed In Error");
	}
}
